
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruit/jobs/[city]/page/[page]",
      function () {
        return require("private-next-pages/recruit/jobs/[city]/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruit/jobs/[city]/page/[page]"])
      });
    }
  